import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details hidden-sm" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
    /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tDashboard\r\n\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-download" }, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Export", -1 /* HOISTED */);
const _hoisted_8 = { class: "form-contents" };
const _hoisted_9 = { class: "row" };
const _hoisted_10 = { class: "col-xs-12 col-sm-12" };
const _hoisted_11 = { class: "x_panel map-wrapper" };
const _hoisted_12 = { class: "x_title map-header" };
const _hoisted_13 = { class: "clearfix tile_count tile-systems-count" };
const _hoisted_14 = { class: "col-xs-3 col-sm-3 col-md-3 tile_stats_count" };
const _hoisted_15 = { class: "clearfix" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-desktop" }),
    /*#__PURE__*/ _createTextVNode(" "),
    /*#__PURE__*/ _createElementVNode("label", null, "Total Systems")
], -1 /* HOISTED */);
const _hoisted_17 = { class: "count clearfix" };
const _hoisted_18 = { class: "col-xs-3 col-sm-3 col-md-3 tile_stats_count healthy" };
const _hoisted_19 = { class: "clearfix" };
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-check-circle-o" }),
    /*#__PURE__*/ _createTextVNode(" "),
    /*#__PURE__*/ _createElementVNode("label", null, "Ok")
], -1 /* HOISTED */);
const _hoisted_21 = { class: "count clearfix" };
const _hoisted_22 = { class: "col-xs-3 col-sm-3 col-md-3 tile_stats_count warning" };
const _hoisted_23 = { class: "clearfix" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-bell" }),
    /*#__PURE__*/ _createTextVNode(" "),
    /*#__PURE__*/ _createElementVNode("label", null, "Warning")
], -1 /* HOISTED */);
const _hoisted_25 = { class: "count clearfix" };
const _hoisted_26 = { class: "col-xs-3 col-sm-3 col-md-3 tile_stats_count critical" };
const _hoisted_27 = { class: "clearfix" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-exclamation-triangle" }),
    /*#__PURE__*/ _createTextVNode(" "),
    /*#__PURE__*/ _createElementVNode("label", null, "Critical")
], -1 /* HOISTED */);
const _hoisted_29 = { class: "count clearfix" };
const _hoisted_30 = { class: "col-xs-3 col-sm-3 col-md-3 tile_stats_count unknown" };
const _hoisted_31 = { class: "clearfix" };
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-question-circle-o" }),
    /*#__PURE__*/ _createTextVNode(" "),
    /*#__PURE__*/ _createElementVNode("label", null, "Offline")
], -1 /* HOISTED */);
const _hoisted_33 = { class: "count clearfix" };
const _hoisted_34 = { class: "x_content map-content" };
const _hoisted_35 = { class: "clearfix top10" };
const _hoisted_36 = { class: "clearfix" };
const _hoisted_37 = {
    class: "col-xs-12 col-sm-12 col-md-3",
    style: { "z-index": "1001" }
};
const _hoisted_38 = { class: "input-group top_search" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = {
    key: 0,
    class: "multiselect__single"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = { class: "font-weight-normal" };
const _hoisted_43 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_44 = { class: "input-group top_search" };
const _hoisted_45 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_46 = { class: "input-group top_search" };
const _hoisted_47 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_49 = {
    id: "dashboard-map",
    ref: "dashboardMap",
    class: "map-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_systemDashboardVue = _resolveComponent("systemDashboardVue");
    const _component_b_tab = _resolveComponent("b-tab");
    const _component_stringDashboardVue = _resolveComponent("stringDashboardVue");
    const _component_b_tabs = _resolveComponent("b-tabs");
    const _component_DashboardReportFilterVue = _resolveComponent("DashboardReportFilterVue");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.showSummaryStatusReportModal
                    }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.setStatusFilter('')))
                                            }, _toDisplayString(_ctx.data.totalNumberOfSystems), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _hoisted_20,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_21, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.setStatusFilter('healthy')))
                                            }, _toDisplayString(_ctx.data.totalNumberOfHealthySystems), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("div", _hoisted_23, [
                                        _hoisted_24,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.setStatusFilter('warning')))
                                            }, _toDisplayString(_ctx.data.totalNumberOfWarningSystems), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _hoisted_28,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_29, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.setStatusFilter('critical')))
                                            }, _toDisplayString(_ctx.data.totalNumberOfCriticalSystems), 1 /* TEXT */)
                                        ])
                                    ])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_33, [
                                            _createElementVNode("a", {
                                                href: "#",
                                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.setStatusFilter('unknown')))
                                            }, _toDisplayString(_ctx.data.totalNumberOfUnknownSystems), 1 /* TEXT */)
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createVNode(_component_multiselect, {
                                                options: _ctx.systemStates,
                                                "track-by": "value",
                                                label: "text",
                                                multiple: true,
                                                showLabels: false,
                                                placeholder: "",
                                                preserveSearch: true,
                                                closeOnSelect: false,
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                placeholder: _withCtx(() => [
                                                    (!_ctx.numberOfSeletedStatus)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tNone selected\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                selection: _withCtx(({ search, isOpen }) => [
                                                    (_ctx.numberOfSeletedStatus && !isOpen)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.statusOptionText), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                option: _withCtx((props) => [
                                                    _createElementVNode("div", {
                                                        onClick: _withModifiers(($event) => (_ctx.selectStatus(props.option)), ["stop"])
                                                    }, [
                                                        (_openBlock(), _createBlock(_component_b_form_checkbox, {
                                                            id: 'status-' + props.option.value,
                                                            key: _ctx.getComponentKey(props.option),
                                                            checked: props.option.selected
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createElementVNode("label", _hoisted_42, _toDisplayString(props.option.text), 1 /* TEXT */)
                                                            ]),
                                                            _: 2 /* DYNAMIC */
                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "checked"]))
                                                    ], 8 /* PROPS */, _hoisted_41)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.selectedCompanyId,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                                                options: _ctx.companies,
                                                "track-by": "value",
                                                label: "text",
                                                showLabels: false,
                                                placeholder: "All companies",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                            _createVNode(_component_multiselect, {
                                                modelValue: _ctx.selectedSite,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.selectedSite) = $event)),
                                                options: _ctx.sites,
                                                "track-by": "value",
                                                label: "text",
                                                showLabels: false,
                                                placeholder: "Any site",
                                                class: "multiselect-small"
                                            }, {
                                                noResult: _withCtx(() => [
                                                    _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["modelValue", "options"])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_47, [
                                        _createVNode(_component_b_button, {
                                            variant: "outline-secondary",
                                            onClick: _ctx.resetFilters
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_48,
                                                _createTextVNode(" Reset\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createVNode(_component_b_tabs, {
                                modelValue: _ctx.activeTab,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.activeTab) = $event)),
                                "nav-wrapper-class": "tabs",
                                onActivateTab: _ctx.ensureMapIsRendered
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_tab, {
                                        key: "status",
                                        title: "Systems"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_systemDashboardVue, {
                                                companyFilter: _ctx.companyFilter,
                                                siteFilter: _ctx.siteFilter,
                                                systemStates: _ctx.systemStates,
                                                visibleSystems: _ctx.visibleSystems,
                                                filteredSystemsUnknown: _ctx.getFilteredSystemsUnknown,
                                                onOnDataLoaded: _ctx.dataLoaded
                                            }, null, 8 /* PROPS */, ["companyFilter", "siteFilter", "systemStates", "visibleSystems", "filteredSystemsUnknown", "onOnDataLoaded"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createTextVNode(),
                                    _createVNode(_component_b_tab, {
                                        key: "strings",
                                        title: "Strings"
                                    }, {
                                        default: _withCtx(() => [
                                            (_ctx.firstTimeTabBlocks)
                                                ? (_openBlock(), _createBlock(_component_stringDashboardVue, {
                                                    key: 0,
                                                    companyFilter: _ctx.companyFilter,
                                                    siteFilter: _ctx.siteFilter,
                                                    systemStates: _ctx.systemStates,
                                                    filteredSystemsUnknown: _ctx.getFilteredSystemsUnknown
                                                }, null, 8 /* PROPS */, ["companyFilter", "siteFilter", "systemStates", "filteredSystemsUnknown"]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    }),
                                    _createTextVNode(),
                                    (_ctx.isCloud)
                                        ? (_openBlock(), _createBlock(_component_b_tab, {
                                            key: "map",
                                            title: "Map"
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_49, null, 512 /* NEED_PATCH */)
                                            ]),
                                            _: 1 /* STABLE */
                                        }))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "onActivateTab"])
                        ])
                    ])
                ])
            ]),
            _createTextVNode(),
            _createVNode(_component_DashboardReportFilterVue, {
                modelValue: _ctx.showReportModal,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.showReportModal) = $event)),
                isModal: true,
                initialCompanyId: _ctx.companyFilter,
                initialSiteId: _ctx.siteFilter
            }, null, 8 /* PROPS */, ["modelValue", "initialCompanyId", "initialSiteId"])
        ]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
